export class MedicalOrderOperation {
  public Protocol: string;
  public MedicalApponitmentId: number;
  public MedicalApponitmentIds: number[];
  public MedicalOrderId: number;
  public HasPreviousStudies: boolean;
  public ApplyPreviousStudies: boolean;
}
